(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nco-contact"] && !Shopify.designMode) return;
  try {
    

(() => {
  function initialize(scope) {
    const roots = scope.matches && scope.matches('[data-nco-contact]') ? [scope] : scope.querySelectorAll('[data-nco-contact]');
    roots.forEach(root => {
      if (root.dataset.contactReady) return;
      root.dataset.contactReady = 'true';
      const topics = Array.from(root.querySelectorAll('[data-nc-topic]'));
      const panels = Array.from(root.querySelectorAll('[data-nc-panel]'));
      const message = root.querySelector('[data-nc-message]');
      const orderField = root.querySelector('[data-nc-order-field]');
      function refresh() {
        const chosen = topics.find(input => input.checked);
        if (!chosen) return;
        panels.forEach(panel => {
          panel.hidden = panel.dataset.ncPanel !== chosen.dataset.ncTopic;
          if (!panel.hidden && message) message.placeholder = panel.dataset.placeholder;
        });
        if (orderField) orderField.hidden = chosen.dataset.ncTopic !== 'order';
      }
      topics.forEach(input => input.addEventListener('change', refresh));
      refresh();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nco-education"] && !Shopify.designMode) return;
  try {
    

(() => {
  function initialize(scope) {
    const roots = scope.matches && scope.matches('[data-nco-edu]') ? [scope] : scope.querySelectorAll('[data-nco-edu]');
    roots.forEach(root => {
      if (root.dataset.eduReady) return;
      root.dataset.eduReady = 'true';
      root.querySelectorAll('[data-edu-switch]').forEach(group => {
        const own = selector => Array.from(group.querySelectorAll(selector)).filter(el => el.closest('[data-edu-switch]') === group);
        const buttons = own('[data-edu-choice]');
        const panels = own('[data-edu-panel]');
        buttons.forEach(button => button.addEventListener('click', () => {
          buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          panels.forEach(item => { item.hidden = item.dataset.eduPanel !== button.dataset.eduChoice; });
        }));
      });
      const carat = root.querySelector('[data-edu-carat]');
      if (carat) {
        const output = root.querySelector('[data-edu-carat-value]');
        const shape = root.querySelector('[data-edu-carat-art] svg');
        const refresh = () => {
          const weight = Number(carat.value);
          output.textContent = weight.toFixed(2) + ' ct · ' + (weight * 0.2).toFixed(2) + ' g';
          shape.style.transform = 'scale(' + (Math.cbrt(weight) * 0.8).toFixed(3) + ')';
          carat.setAttribute('aria-valuetext', output.textContent);
        };
        carat.addEventListener('input', refresh);
        refresh();
      }
      const checklist = root.querySelector('[data-edu-checklist]');
      if (checklist) {
        const output = checklist.querySelector('[data-edu-check-output]');
        checklist.addEventListener('change', () => {
          output.textContent = output.dataset.template.replace('{count}', String(checklist.querySelectorAll('[data-edu-check]:checked').length));
        });
      }
      const tool = root.querySelector('[data-edu-size]');
      if (tool) {
        const diameters = tool.dataset.sizes.split(',').map(Number);
        const measure = tool.querySelector('[data-edu-measure]');
        const field = tool.querySelector('[data-edu-measurement]');
        const unit = tool.querySelector('[data-edu-unit]');
        const output = tool.querySelector('[data-edu-size-result]');
        const clear = () => { output.textContent = output.dataset.empty; field.removeAttribute('aria-invalid'); };
        const calculate = () => {
          const value = Number(field.value);
          if (field.value.trim() === '' || !Number.isFinite(value) || value <= 0) {
            output.textContent = output.dataset.invalid;
            field.setAttribute('aria-invalid', 'true');
            return;
          }
          const mm = value * (unit.value === 'in' ? 25.4 : 1);
          const diameter = measure.value === 'circumference' ? mm / Math.PI : mm;
          if (diameter < diameters[0] - 0.001 || diameter > diameters[diameters.length - 1] + 0.001) {
            output.textContent = output.dataset.outside;
            field.setAttribute('aria-invalid', 'true');
            return;
          }
          let best = 0;
          diameters.forEach((candidate, i) => {
            if (Math.abs(candidate - diameter) <= Math.abs(diameters[best] - diameter) + 0.000001) best = i;
          });
          field.removeAttribute('aria-invalid');
          output.textContent = output.dataset.template.replace('{size}', String(3 + best * 0.5));
        };
        tool.querySelector('[data-edu-calculate]').addEventListener('click', calculate);
        field.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); calculate(); } });
        field.addEventListener('input', clear);
        [measure, unit].forEach(control => control.addEventListener('change', () => {
          field.value = '';
          field.placeholder = unit.value === 'in' ? (measure.value === 'diameter' ? '0.681' : '2.140') : (measure.value === 'diameter' ? '17.3' : '54.3');
          clear();
        }));
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
